import { competeScore } from "../../lib/competitiveSort";

// Ids of rows whose exact Compete score equals the row directly above or below in the order shown.
export function sameScoreIds(displayed, idOf = (r) => r?.degree_id || r?.university_id) {
  const ids = new Set();
  for (let i = 1; i < (displayed || []).length; i++) {
    const a = competeScore(displayed[i - 1]);
    if (a != null && a === competeScore(displayed[i])) {
      ids.add(idOf(displayed[i - 1]));
      ids.add(idOf(displayed[i]));
    }
  }
  return ids;
}

// Shown order for a grouped list: each flagship, then its variations if expanded.
export const groupedDisplayOrder = (groups, isExpanded) =>
  groups.flatMap((g) => [g.flagship, ...(isExpanded(g.university_id) ? g.variations : [])]);

export function SameScoreTag({ r, testId }) {
  const score = competeScore(r);
  return (
    <span data-testid={testId}
      title={`Same Compete score (${Math.round(score * 100)}) as the course next to it. Tied courses are ordered by the lower offer rate, then university and course name A → Z.`}
      className="inline-flex items-center px-1.5 py-0.5 rounded border border-dashed border-indigo-300 bg-white text-indigo-700 text-[10px] normal-case tracking-normal">
      Same score
    </span>
  );
}
